import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useUpdateRequirePracticeArea = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, boolean>({
    mutationFn: async (requirePracticeArea: boolean) => {
      const response = await fetch(
        `${APIBaseChronos}/api/org/require-practice-area`,
        getFetchConfig({ method: FetchMethod.PATCH, data: { requirePracticeArea } }),
      );

      if (!response.ok) throw new Error('Failed to update practice area setting');
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.User]);
      queryClient.invalidateQueries([QueryEntity.OrganisationById]);
    },
  });
};
